import { render, staticRenderFns } from "./Architecture.vue?vue&type=template&id=9b28d0bc&"
import script from "./Architecture.vue?vue&type=script&lang=js&"
export * from "./Architecture.vue?vue&type=script&lang=js&"
import style0 from "./Architecture.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports